import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getPurchasesDetailsFleet, getPurchasesDetailsFleetSuccess, getDossierParentSubtypeDetailCount, getFleetOperations } from '../../../../actions/management/management'
import { openModal } from '../../../../actions/common'
import PurchaseFleetListComponent from '../../../../components/management/fleets/relatedDossiers/PurchaseFleetListComponent'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.management.purchaseFleetComponent,
    purchaseFleetDetails: state.management.purchaseFleetDetails,
    purchaseCount: state.management.parentSubtypeCount[state.management.createNewFleetModal?.fleet?.dossierSubType === dossierSubTypeId.venta_vn ? dossierSubTypeId.compra_vn : dossierSubTypeId.compra_vo] || 0,
    dataPurchaseActions: state.management.operateFleetModal.dataPurchaseActions,
    operationPurchaseActions: state.management.operateFleetModal.operationPurchaseActions
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openModal,
      getPurchasesDetailsFleet,
      getPurchasesDetailsFleetSuccess,
      getDossierParentSubtypeDetailCount,
      getFleetOperations
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(PurchaseFleetListComponent, true)))
